(() => {
  if (window.__nssBogosCartGateInstalled) return;
  window.__nssBogosCartGateInstalled = true;

  let deferNextOpen = false;
  let pendingOpen = false;
  let fallbackTimer = null;
  let originalOpen = null;
  let bogosUpdated = false;
  let loaderGuardTimer = null;
  let settleTimer = null;

  // const selectedAutoShip = (form) => {
  //   if (!form || form.dataset?.apOtpIntent === '1') return false;

  //   const plan = form.querySelector('[name="selling_plan"]');
  //   if (plan?.value) return true;

  //   // Perform Variety writes selling_plan only during its capture-phase submit
  //   // handler. At the earlier CTA click and gate submit listener the hidden
  //   // input can still be empty, so read the actual AutoShip UI state too.
  //   const buybox = form.closest('nss-buybox');
  //   const subRadio = buybox?.querySelector('[nss-radio-sub]');
  //   const otpRadio = buybox?.querySelector('[nss-radio-otp]');
  //   if (subRadio) return Boolean(subRadio.checked);
  //   if (otpRadio?.checked) return false;

  //   const activeTier = buybox?.querySelector('.js-nss-quantity-selector.active');
  //   return Boolean(activeTier?.dataset?.sellingPlanId);
  // };

  const selectedAutoShip = form => {
    if (!form || form.dataset?.apOtpIntent === "1") return false;
    if (form.querySelector('[name="selling_plan"]')?.value) return true;

    const buybox   = form.closest("nss-buybox");
    const subRadio = buybox?.querySelector("[nss-radio-sub]");
    const otpRadio = buybox?.querySelector("[nss-radio-otp]");

    if (subRadio) return !!subRadio.checked;
    if (otpRadio?.checked) return false;

    const ds = buybox?.querySelector(".js-nss-quantity-selector.active")?.dataset || {};
    return !!(ds.sellingPlanId || ds.bundleASellingPlanId || ds.bundleBSellingPlanId);
  };

  const refreshDrawer = async () => {
    const cart = document.querySelector('[nss-cart-handler]');
    const sectionId = cart?.getAttribute('nss-parent-section-id');
    if (!cart || !sectionId) return;

    const separator = window.location.search ? '&' : '?';
    const response = await fetch(
      `${window.location.pathname}${window.location.search}${separator}section_id=${encodeURIComponent(sectionId)}&bogos_cart_gate=${Date.now()}`,
      { cache: 'no-store', headers: { Accept: 'text/html' } }
    );
    if (!response.ok) throw new Error(`Cart refresh failed: ${response.status}`);

    const fresh = new DOMParser().parseFromString(await response.text(), 'text/html');
    const currentList = cart.querySelector('[nss-cart-product-list]');
    const freshList = fresh.querySelector('[nss-cart-product-list]');
    if (currentList && freshList) currentList.replaceWith(freshList);

    cart.querySelectorAll('[nss-cart-reload]').forEach((current) => {
      const key = current.getAttribute('nss-cart-reload');
      const replacement = fresh.querySelector(`[nss-cart-reload="${CSS.escape(key)}"]`);
      if (replacement) current.replaceWith(replacement);
    });

    const count = freshList?.getAttribute('nss-cart-item-count');
    if (count != null) {
      document.querySelectorAll('[nss-cart-count], [nss-cart-badge-count]').forEach((node) => {
        node.textContent = count;
      });
    }
  };

  const bogosGiftsCommitted = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Cart verification failed: ${response.status}`);
    const cart = await response.json();
    const paidSubscriptionPouches = (cart.items || []).reduce((total, item) => {
      const sku = String(item.sku || '').toUpperCase();
      const isPouch = sku.startsWith('HYPH') && sku.endsWith('15');
      return total + (isPouch && item.selling_plan_allocation && Number(item.final_price) > 0
        ? Number(item.quantity || 0) : 0);
    }, 0);
    if (!paidSubscriptionPouches) return true;

    const present = new Set((cart.items || []).map((item) => String(item.sku || '').toUpperCase()));
    // 8 Oct 2026: BOGOS now adds the new bottle (MHWBCLRD750N); accept it as the bottle so the drawer isn't held for 30s.
    if (present.has('MHWBCLRD750N')) present.add('MHWBCLRD750');
    const required = ['HYPHMXB5', 'MHWBCLRD750'];
    if (paidSubscriptionPouches >= 4) required.push('CREDIT25', 'HYDBOOK');
    if (!required.every((sku) => present.has(sku))) return false;
    // 60-stick merch gift: Ice Cube Tray (MHHYRICE) since 16 Sep 2026; Habit Diary (MHJOURNAL) accepted for legacy carts.
    if (paidSubscriptionPouches >= 4 && !present.has('MHHYRICE') && !present.has('MHJOURNAL')) return false;
    return true;
  };

  const ensureLoadingOverlay = () => {
    const wrapper = document.querySelector('nss-slidecart .nss-slidecart__inner-wrapper');
    if (!wrapper || wrapper.querySelector('.nss-cart-loading-overlay')) return;
    wrapper.style.position = 'relative';
    const overlay = document.createElement('div');
    overlay.className = 'nss-cart-loading-overlay';
    overlay.setAttribute('data-bogos-gate-loader', '');
    overlay.innerHTML = '<div class="nss-cart-loader"></div>';
    wrapper.appendChild(overlay);
  };

  const holdLoadingOverlay = () => {
    clearInterval(loaderGuardTimer);
    ensureLoadingOverlay();
    loaderGuardTimer = setInterval(ensureLoadingOverlay, 100);
  };

  const releaseLoadingOverlay = () => {
    clearInterval(loaderGuardTimer);
    loaderGuardTimer = null;
    document.querySelectorAll('nss-slidecart .nss-cart-loading-overlay').forEach((overlay) => {
      overlay.classList.add('nss-cart-fade-out');
      setTimeout(() => overlay.remove(), 300);
    });
  };

  const finishPendingOpen = async () => {
    if (!pendingOpen) return;
    pendingOpen = false;
    clearTimeout(fallbackTimer);
    fallbackTimer = null;

    try {
      await refreshDrawer();
    } catch (error) {
      console.warn('[NSS] BOGOS cart refresh fallback:', error);
    }
    releaseLoadingOverlay();
    originalOpen?.();
  };

  const waitForBogosToSettle = () => {
    if (!pendingOpen || !bogosUpdated) return;
    clearTimeout(settleTimer);
    // BOGOS can emit just before its final cart mutation resolves. Debounce the
    // completion event, then render the server cart once. Do not poll /cart.js:
    // repeated polling can rate-limit the same session and prevent BOGOS itself
    // from reading the cart.
    settleTimer = setTimeout(async () => {
      settleTimer = null;
      if (!pendingOpen) return;
      try {
        // BOGOS can announce completion before its cart writes have committed.
        // Verify the actual Shopify cart once before exposing checkout. One
        // read replaces the former 24-request polling loop.
        if (await bogosGiftsCommitted()) {
          finishPendingOpen();
          return;
        }
        bogosUpdated = false;
        if (window.BOGOS_CORE?.helper?.gift?.prepareCheckout) {
          window.BOGOS_CORE.helper.gift.prepareCheckout();
        }
      } catch (error) {
        console.warn('[NSS] BOGOS commit verification:', error);
      }
      // Keep the loader up and allow BOGOS' next completion event to retry.
      // The existing 30-second escape still protects conversion from deadlock.
    }, 600); // 9 Oct 2026 (Nathan): settle wait 2000 -> 600ms to shorten the cart loader
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('.shopify-product-form');
    deferNextOpen = selectedAutoShip(form);
  }, true);

  // The subscription/free-shipping handler registers an earlier document-level
  // submit listener and calls stopImmediatePropagation(), so a later submit
  // listener is not guaranteed to run. Prime the gate from the user's CTA click
  // at window capture phase, before that handler can intercept the submit.
  window.addEventListener('click', (event) => {
    const submitter = event.target.closest?.(
      '.shopify-product-form button[type="submit"], .shopify-product-form input[type="submit"]'
    );
    if (!submitter) return;
    deferNextOpen = selectedAutoShip(submitter.closest('.shopify-product-form'));
  }, true);

  const installOpenGate = () => {
    if (typeof window.NSS_OPEN_CART !== 'function' || window.NSS_OPEN_CART.__bogosGate) return false;
    originalOpen = window.NSS_OPEN_CART.bind(window);
    const gatedOpen = () => {
      if (!deferNextOpen) return originalOpen();
      deferNextOpen = false;
      pendingOpen = true;
      bogosUpdated = false;
      clearTimeout(settleTimer);
      settleTimer = null;
      clearTimeout(fallbackTimer);
      // Open immediately so the customer gets feedback, but keep the loading
      // state visible until BOGOS has finished and the fresh cart is rendered.
      originalOpen();
      holdLoadingOverlay();
      // BOGOS can take 15-20 seconds to finish after the product add. Never
      // treat an unchanged product-only cart as settled before its completion
      // event. This timeout is only a deadlock escape, not the normal path.
      fallbackTimer = setTimeout(() => {
        if (pendingOpen) finishPendingOpen();
      }, 30000);
    };
    gatedOpen.__bogosGate = true;
    window.NSS_OPEN_CART = gatedOpen;
    return true;
  };

  if (!installOpenGate()) {
    const installTimer = setInterval(() => {
      if (installOpenGate()) clearInterval(installTimer);
    }, 50);
    setTimeout(() => clearInterval(installTimer), 5000);
  }

  document.addEventListener('fg-gifts:updated', () => {
    bogosUpdated = true;
    waitForBogosToSettle();
  });
})();
